import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AllCategory from '../sports/Sports'

function CategoryRoute() {
  return (
    <>
      <Routes>
        <Route path='/all-sports' element={<AllCategory/>}/>
      </Routes>
    </>
  )
}

export default CategoryRoute
